import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import {
    View,
    FlatList,
    TouchableOpacity
} from 'react-native';

import {
    JDText,
    JDImage,
    JDScrollView
} from '@jdreact/jdreact-core-lib';

import CardItem from '../../components/movieCard/card-item';
import LoadingAnimation from '../../components/index/loading-animation';

import st from '../../style/movie-card/info.st';
import { get } from '../../common/fetch';
import { pt, fetchLocal } from '../../common/utils';
import sgmReport from '../../common/sgmUtil';

class MovieCardInfo extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            cinemaList: [],
            citys: []
        };
        this.toIndex = this.toIndex.bind(this);
        this.getCertRule = this.getCertRule.bind(this);

        this.pageNum = 1;
        this.totalPage = 0;
    }

    render() {
        const { movieCertRuleId, canUse } = this.props;

        const { cinemaList, citys } = this.state;

        const { pageNum, totalPage } = this;
        const numbers = new Array(15).fill(0);

        const listItems = numbers.map((number, index) => <View key={ index } style={ st.dot_white } />);

        const cardInfo = fetchLocal('CardInfo');

        return (
            <View style={ { flex: 1 } }>

                {this.setTitle('兑换券详情')}
                <JDScrollView
                    showsVerticalScrollIndicator={ false }
                    contentContainerStyle={ st.content_wrap }
                    onScroll={ (e) => this._onScroll(e) }
                    style={ st.container }
                >

                    <CardItem cardInfo={ cardInfo } canUse={ canUse } />

                    <View style={ st.info_cont }>

                        <View style={ { alignItems: 'center' } }>
                            <View style={ st.tooth }>
                                {listItems}
                            </View>
                        </View>

                        <View style={ st.info }>
                            <View style={ st.info_top }>
                                <View style={ st.info_title }>
                                    <JDImage style={ st.title_img } source={ img.title_icon } />
                                    <JDText style={ st.title }>京东电影兑换券说明</JDText>
                                </View>
                                <JDText style={ st.info_text }>京东电影兑换券（以下简称“兑换券”）为虚拟兑换券，本券为您在京东电影票平台兑换电影票次数的记录。券内无金额，一经购买，不可退换，不记名、不挂失。本兑换券不得转卖，不得以任何理由在规定影院处兑换现金或折抵消费款项。您购买成功后即可通过京东电影平台自助兑换电影票。</JDText>
                                {/* <JDText style={st.info_text}>本兑换券不得转卖，不得以任何理由在规定影院处兑换现金或折抵消费款项。您购买成功后即可通过京东电影平台自助兑换电影票。</JDText> */}
                            </View>

                            <View style={ st.info_container }>
                                <JDText style={ st.dot } />
                                <JDText style={ st.info_text }>兑换券仅用于在京东电影票平台购买影票时，直接兑换规则内的电影票一张。兑换券不可在非协议影院消费。</JDText>
                            </View>
                            <View style={ st.info_container }>
                                <JDText style={ st.dot } />
                                <JDText style={ st.info_text }>电影兑换券使用规则： 持卡人在兑换券有效期内，可通过京东电影票平台在线选座渠道进行购票，直接使用此券兑换电影票。以防止非正常用卡行为，在获取或使用兑换券的过程中，如出现违规行为（如作弊获取、恶意套现、虚假交易、批量下单等），本平台有权限制单张兑换券在一定时段内的购票次数，甚至无法使用。受不同影片和优惠活动的影响，同一影院的票价有可能随时发生变动，对于这些变动，将不另行通知，票价以实际购票时的价格为准。该产品通用兑换规则为每个批次，可以绑定兑换券数量6张。同一用户PIN/手机号，当月（当月1日0点至次月1日0点）累计兑换次数不可超过15次，超出后卡面为灰色不可用状态。特殊情况，系统会根据用户风险等级判定限制绑定及使用数量，具体以系统提示为准。请用户规范用券。第三方平台获取兑换券，例如积分兑换/福利兑换平台等非京东直接发放批次，以发放平台公示得绑定和使用规则为准，如有问题，还请直接联系发放平台。本兑换券支持多种有效期，具体有效期时间请查看已绑定兑换券卡面展示信息。本兑换券支持多种有效期，具体有效期时间请查看已绑定兑换券卡面展示信息。</JDText>
                            </View>
                            <View style={ st.info_container }>
                                <JDText style={ st.dot } />
                                <JDText style={ st.info_text }>关于卡的丢失：兑换券为不记名卡，若出现丢失、毁损等情况不挂失、不补办。请妥善保管。</JDText>
                            </View>
                            <View style={ st.info_container }>
                                <JDText style={ st.dot } />
                                <JDText style={ st.info_text }>您同意并认可，京东电影权益券的使用规则。本兑换券不会因平台规则变化而对兑换电影票产生影响。请放心使用。</JDText>
                            </View>
                            <View style={ st.info_container }>
                                <JDText style={ st.dot } />
                                <JDText style={ st.info_text }>持卡人使用兑换券时请同时遵守京东电影票平台及影院的相关规定。</JDText>
                            </View>
                            <View style={ st.info_container }>
                                <JDText style={ st.dot } />
                                <JDText style={ st.info_text }>如有任何问题，可拨打京东电影票客服电话咨询：400-616-5500。</JDText>
                            </View>
                        </View>

                    </View>

                    {!!cinemaList.length && !!movieCertRuleId &&
                        <SupportCinema cinemaList={ cinemaList } />
                    }

                    {!!citys.length && !!movieCertRuleId &&
                        <SupportCity citys={ citys } />
                    }

                    {pageNum <= totalPage && !!movieCertRuleId &&
                        <LoadingAnimation />
                    }

                    {pageNum > totalPage && !!movieCertRuleId &&
                        <View style={ { alignItems: 'center', justifyContent: 'center', marginVertical: pt(10) } }>
                            <JDText>我是有底线的(^_^)</JDText>
                        </View>
                    }

                </JDScrollView>

                <TouchableOpacity style={ st.footer } activeOpacity={ 0.5 } onPress={ this.toIndex }>
                    <JDText style={ st.pay }>立即购票</JDText>
                </TouchableOpacity>

                <View style={ {
                    height: iphoneXMarginBottom,
                    backgroundColor: '#fff',
                    width: '100%'
                } } />

            </View>
        );
    }

    componentDidMount() {
        const { movieCertRuleId } = this.props;

        if (movieCertRuleId !== 'null' && movieCertRuleId !== 'undefined') {
            this.getCertRule();
        }
    }

    setTitle = (title) => {
        document.title = title;
    }

    getCertRule(pageNum = 1, pageSize = 20) {
        const { movieCertRuleId } = this.props;

        const data = {
            movieCertRuleId,
            pageNum,
            pageSize
        };

        get('getCertRule', data).then(res => {
            let certRuleInfos = res.data.certRuleInfos || [];

            const limitType = res.data.limitType;

            const totalPage = res.data.totalPage;

            const cinemaList = JSON.parse(JSON.stringify(this.state.cinemaList));

            const citys = JSON.parse(JSON.stringify(this.state.citys));

            this.pageNum++;
            this.totalPage = totalPage;

            if (limitType == 1) {
                certRuleInfos = cinemaList.concat(certRuleInfos);

                this.setState({ cinemaList: certRuleInfos });
            }

            if (limitType == 2) {
                certRuleInfos = citys.concat(certRuleInfos);

                this.setState({ citys: certRuleInfos });
            }

            setTimeout(() => {
                this.pageLoading = false;
            }, 500);
        }).catch(() => {
        });

        if(!movieCertRuleId){
            sgmReport('1001', {function_id: 'getCertRule',message:'缺少参数movieCertRuleId'}, 3)
        }
    }

    toIndex() {
        this.context.router.toIndex();
    }

    _onScroll(e) {
        const { movieCertRuleId } = this.props;

        if (!movieCertRuleId) return;

        const info = e.nativeEvent;

        const height = info.contentSize.height;

        const scrollHeight = info.contentOffset.y;

        const screenHeight = info.layoutMeasurement.height;

        const pageLoading = this.pageLoading;

        const totalPage = this.totalPage;

        const pageNum = this.pageNum;

        if (scrollHeight + screenHeight + 40 > height && pageNum <= totalPage && !pageLoading) {
            this.pageLoading = true;

            this.getCertRule(pageNum);
        }
    }
}

MovieCardInfo.contextTypes = {
    router: PropTypes.object
};

class SupportCinema extends PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        const { cinemaList } = this.props;

        return (
            <View style={ st.supportCinema }>
                <View style={ st.support_title }>
                    <View style={ st.title_text }>
                        <View style={ st.line } />
                        <JDText style={ st.support_title_text }>支持影院</JDText>
                        <View style={ st.line } />
                    </View>

                    {/* <View style={st.cinema_num}>
                        <JDImage source={img.located} style={st.located} />
                        <JDText style={st.num_text}>北京</JDText>
                        <JDText style={[st.num_text, { marginLeft: pt(5) }]}>11家, 全国333家</JDText>
                    </View> */}
                </View>

                <View style={ { paddingLeft: pt(10), paddingRight: pt(10) } }>
                    <FlatList
                        data={ cinemaList }
                        initialNumToRender={ 5 }
                        keyExtractor={ (item, index) => index + '' }
                        renderItem={ ({ item }) => {
                            return (
                                <View
                                    style={ st.cinema_item_wrap }
                                >
                                    <View style={ st.cinema_name_price_wrap }>
                                        <JDText
                                            numberOfLines={ 1 }
                                            style={ st.cinema_name }
                                        >
                                            {item.name}
                                        </JDText>
                                    </View>

                                    <View style={ st.cinema_address_wrap }>
                                        <JDText
                                            style={ st.cinema_address }
                                            numberOfLines={ 1 }
                                        >
                                            {item.desc}
                                        </JDText>
                                    </View>
                                </View>
                            );
                        } }
                    />
                </View>
            </View>
        );
    }
}

class SupportCity extends PureComponent {
    render() {
        const { citys } = this.props;

        return (
            <View style={ st.supportCinema }>
                <View style={ st.support_title }>
                    <View style={ st.title_text }>
                        <View style={ st.line } />
                        <JDText style={ st.support_title_text }>支持城市</JDText>
                        <View style={ st.line } />
                    </View>
                </View>

                <View>
                    <FlatList
                        data={ citys }
                        initialNumToRender={ 5 }
                        keyExtractor={ (item, index) => index + '' }
                        renderItem={ ({ item }) => {
                            return (
                                <View style={ st.city_item }>
                                    <JDText numberOfLines={ 1 } style={ st.city_name }>{item.name}</JDText>
                                </View>
                            );
                        } }
                    />
                </View>
            </View>
        );
    }
}

const img = {
    located: require('../../img/located.png'),
    title_icon: require('../../img/movie-card/icon.png')
};

const select = (state) => {
    const { cardInfo } = state.movieCard;

    return { cardInfo };
};

export default connect(select, null, null, { withRef: true })(MovieCardInfo);
